import * as React from 'react';

import moment from 'moment';

import {FormattedTimestamp} from '../../timestamp/formatted-timestamp';
import {RelativeTimestamp} from '../../timestamp/relative-timestamp';
import {Body} from '../../typography/body';

type Props = {
    lastSeenTime: string | null | undefined;
    isActive: boolean | null | undefined;
};

export function ThreadHeaderTimestamp(props: Props) {
    const lastSeenTime = Number(props.lastSeenTime);

    if (props.isActive) {
        return (
            <Body size='small' color='light'>
                Chatting now
            </Body>
        );
    }

    return (
        <Body
            size='small'
            color='light'
            title={moment
                .unix(lastSeenTime)
                .format(FormattedTimestamp.formats.longMonthDayYearWithTime)}
        >
            <div className='nowrap flex'>
                <span>Last seen&nbsp;</span>
                <RelativeTimestamp datetime={lastSeenTime} format='fromNow' />
            </div>
        </Body>
    );
}
